exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3eHq1kL3IlXSBcx-V8ywk-{height:75px;width:75px;display:block;border-radius:4px;margin-bottom:1em;margin-top:1em}form input._2leZYf_qfrBL-pAT8A7yMH{margin-bottom:1em;margin-top:1em}\n", ""]);

// Exports
exports.locals = {
	"ColorSample": "_3eHq1kL3IlXSBcx-V8ywk-",
	"urlField": "_2leZYf_qfrBL-pAT8A7yMH"
};